import { createSaga } from './saga-helpers';

import * as Api from '../api/favorites-api';

const watchGetFavorites = createSaga({
    type: 'FAVORITES_FETCH',
    fn: Api.fetchFavorites,
    args: action => [action.payload],
    successPayload: ({ items, hasMore } = {}, action) => ({
        favorites: items,
        hasMore,
        ...action.payload
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        ...action.payload
    })
});

const watchCreateFavorite = createSaga({
    type: 'FAVORITE_CREATE',
    fn: Api.createFavorite,
    args: action => [action.payload.favorite],
    successPayload: ({ id: favoriteId, order }, action) => ({
        favoriteId,
        order,
        fragment: action.payload.favorite
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        fragment: action.payload.favorite
    })
});

const watchUpdateFavorite = createSaga({
    type: 'FAVORITE_UPDATE',
    fn: Api.updateFavorite,
    args: action => [action.payload.favoriteId, action.payload.favoriteProps],
    successPayload: favorite => ({ favorite })
});

const watchRemoveFavorite = createSaga({
    type: 'FAVORITE_REMOVE',
    fn: Api.removeFavorite,
    args: action => [action.payload.favoriteId]
});

const sagas = [watchGetFavorites, watchCreateFavorite, watchUpdateFavorite, watchRemoveFavorite];

export default sagas;
